import { AxiosError } from 'axios'

import { CustomHttpError } from '@/types/error'

export const getCustomHttpError = (err: AxiosError): CustomHttpError | null => {
  if (!err.response) {
    return null
  }

  const url = err.config?.url ?? ''
  const status = err.response.status

  // 注文履歴取得 404: /v1/order-histories/{salesOrderNo}
  if (/^\/v1\/order-histories\/[^/]+$/.test(url) && status === 404) {
    return new CustomHttpError(err.response, 'orderHistoryNotFound')
  }

  // 未出荷注文履歴取得 404: /v1/order-histories/unshipped
  if (url === '/v1/order-histories/unshipped' && status === 404) {
    return new CustomHttpError(err.response, 'orderHistoryNotFound')
  }

  return null
}
